import moment from 'moment';

export const quickPicksOptions = {
  today: 'today',
  fifteenMinutes: 'fifteenMinutes',
  oneHour: 'oneHour',
  threeHours: 'threeHours',
  sixHours: 'sixHours',
  twelveHours: 'twelveHours',
  twentyFourHours: 'twentyFourHours',
  threeDays: 'threeDays',
  sevenDays: 'sevenDays',
  fifteenDays: 'fifteenDays',
  thirtyDays: 'thirtyDays',
  thisMonth: 'thisMonth',
  fortyFiveDays: 'fortyFiveDays',
  sixtyDays: 'sixtyDays',
  ninetyDays: 'ninetyDays',
};

/**
 * displayName - The Quick Pick name displayed to customers
 * referenceNumber - We are storing the time range for a View as an integer. Because this wouldn't
 *   work for "today" or "this month", we are storing the View reference number in this field
 *   (rather than the amount of seconds, for example)
 * startDate - The start of the time period in which events are pulled, relative to current time
 */
export const quickPicksMetadata = {
  [quickPicksOptions.today]: {
    displayName: 'Today',
    referenceValue: 'TODAY',
    startDate: () => moment().startOf('day').toDate(),
  },
  [quickPicksOptions.fifteenMinutes]: {
    displayName: 'Last 15 minutes',
    referenceValue: 'LAST_15_MIN',
    startDate: () => moment().subtract(15, 'minutes').toDate(),
  },
  [quickPicksOptions.oneHour]: {
    displayName: 'Last 1 hour',
    referenceValue: 'LAST_1_HOUR',
    startDate: () => moment().subtract(1, 'hours').toDate(),
  },
  [quickPicksOptions.threeHours]: {
    displayName: 'Last 3 hours',
    referenceValue: 'LAST_3_HOURS',
    startDate: () => moment().subtract(3, 'hours').toDate(),
  },
  [quickPicksOptions.sixHours]: {
    displayName: 'Last 6 hours',
    referenceValue: 'LAST_6_HOURS',
    startDate: () => moment().subtract(6, 'hours').toDate(),
  },
  [quickPicksOptions.twelveHours]: {
    displayName: 'Last 12 hours',
    referenceValue: 'LAST_12_HOURS',
    startDate: () => moment().subtract(12, 'hours').toDate(),
  },
  [quickPicksOptions.twentyFourHours]: {
    displayName: 'Last 24 hours',
    referenceValue: 'LAST_24_HOURS',
    startDate: () => moment().subtract(24, 'hours').toDate(),
  },
  [quickPicksOptions.threeDays]: {
    displayName: 'Last 3 days',
    referenceValue: 'LAST_3_DAYS',
    startDate: () => moment().subtract(3, 'days').toDate(),
  },
  [quickPicksOptions.sevenDays]: {
    displayName: 'Last 7 days',
    referenceValue: 'LAST_7_DAYS',
    startDate: () => moment().subtract(7, 'days').toDate(),
  },
  [quickPicksOptions.fifteenDays]: {
    displayName: 'Last 15 days',
    referenceValue: 'LAST_15_DAYS',
    startDate: () => moment().subtract(15, 'days').toDate(),
  },
  [quickPicksOptions.thirtyDays]: {
    displayName: 'Last 30 days',
    referenceValue: 'LAST_30_DAYS',
    startDate: () => moment().subtract(30, 'days').toDate(),
  },
  [quickPicksOptions.thisMonth]: {
    displayName: 'This month',
    referenceValue: 'THIS_MONTH',
    startDate: () => moment().startOf('month').toDate(),
  },
  [quickPicksOptions.fortyFiveDays]: {
    displayName: 'Last 45 days',
    referenceValue: 'LAST_45_DAYS',
    startDate: () => moment().subtract(45, 'days').toDate(),
  },
  [quickPicksOptions.sixtyDays]: {
    displayName: 'Last 60 days',
    referenceValue: 'LAST_60_DAYS',
    startDate: () => moment().subtract(60, 'days').toDate(),
  },
  [quickPicksOptions.ninetyDays]: {
    displayName: 'Last 90 days',
    referenceValue: 'LAST_90_DAYS',
    startDate: () => moment().subtract(90, 'days').toDate(),
  },
};

Object.keys(quickPicksMetadata).forEach((name) => {
  quickPicksMetadata[name].name = name;
});

export default {
  quickPicksOptions,
  quickPicksMetadata,
};
